function SocialChannel4() {
  return (
    <svg
      width={252}
      height={60}
      viewBox="0 0 252 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M240 54L210.063 17H146.638H-5.72205e-06"
        stroke="#242536"
      />
      <path opacity="0.3" d="M251 38L221.144 1H157.891H1" stroke="#242536" />
      <path d="M220 59L199.227 35H135.837H3" stroke="#242536" strokeOpacity="0.6" />
      <path
        d="M220 59L199.227 35H135.837H3"
        stroke="url(#paint0_linear_2018_48)"
        strokeOpacity="0.7"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2018_48"
          x1="162.653"
          y1="46.7966"
          x2="-155.587"
          y2="43.9831"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#368DFF" stopOpacity={0} />
          <stop offset="0.206121" stopColor="#368DFF" />
          <stop offset="0.207969" stopColor="#368DFF" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>

  );
}

export default SocialChannel4;